import {BaseView} from "../core/view"
import { TrackingUtil } from "../utils/tracking"

export default BaseView.extend({

    el: '.js-related-search-section-mobile',

    events: {
        	'click .js-related-search-mobile-seemore': 'onClickSeeMore'
    },

    onClickSeeMore: function(e) {
	    	let elems = document.getElementsByClassName('js-hidden-simsearch-mobile');
	    	document.getElementsByClassName('js-related-search-mobile-seemore')[0].classList.add("hidden-simsearch-mobile");
	    	for (let i = 0; i < elems.length; ++i) {
	    	    elems[i].classList.remove("hidden-simsearch-mobile");
	    	}
    }

});
